import { businessTypesFromAddress } from "./businessTypes/labels";

// The report's page address: which job, tab, filters and pinned advertiser,
// so a refresh or a copied link opens exactly the same view.
//   ?job=<id>&tab=advertiser&device=mobile&kw=plumber&kw=boiler&pc=S1
//    &type=local&type=national&adv=x.co.uk&adv=name:joesplumbing&hl=y.co.uk&pin=x.co.uk
// Defaults are left out: tab "overview", device "all", no keywords /
// postcodes / types / advertisers (= all), nothing highlighted or pinned.
// hl = advertisers highlighted in yellow (they're not filtered).

const DEVICES = ["mobile", "desktop"];

// "?job=..." -> { jobId, tab, device, keywords, postcodes, businessTypes, advertisers, highlights, pin }
export function parseReportAddress(search) {
  const p = new URLSearchParams(search || "");
  const device = p.get("device");
  return {
    jobId: p.get("job") || null,
    tab: p.get("tab") || null,
    device: DEVICES.includes(device) ? device : "all",
    keywords: p.getAll("kw").filter(Boolean),
    postcodes: p.getAll("pc").filter(Boolean),
    businessTypes: businessTypesFromAddress(p.getAll("type")),
    advertisers: p.getAll("adv").filter(Boolean),
    highlights: p.getAll("hl").filter(Boolean),
    pin: p.get("pin") || null,
  };
}

// The report state -> "?job=..." ("" when there's no job).
export function buildReportAddress({ jobId, tab, device, keywords, postcodes, businessTypes, advertisers, highlights, pin }) {
  if (!jobId) return "";
  const p = new URLSearchParams();
  p.set("job", jobId);
  if (tab && tab !== "overview") p.set("tab", tab);
  if (DEVICES.includes(device)) p.set("device", device);
  for (const k of keywords || []) p.append("kw", k);
  for (const c of postcodes || []) p.append("pc", c);
  for (const t of businessTypes || []) p.append("type", t);
  for (const a of advertisers || []) p.append("adv", a);
  for (const h of highlights || []) p.append("hl", h);
  if (pin) p.set("pin", pin);
  return `?${p.toString()}`;
}

// Keeps only the values the job really has (a copied link may be out of date).
export function onlyKnown(values, known) {
  const allowed = new Set(known || []);
  return (values || []).filter(v => allowed.has(v));
}
